import authMutations from "./auth.mutation";
import authStates from "./auth.state";
import authActions from "./auth.actions";
import authGetters from "./auth.getters";
export default {
  mutations: authMutations,
  state: authStates,
  actions: authActions,
  getters: authGetters
};
